/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Shell_Live_SetsInputs */

const en_us2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 set`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} sets`)
	
};

const pt_br2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 série`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} séries`)
	
};

const es_419_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 serie`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} series`)
	
};

const pt_pt2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 série`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} séries`)
	
};

const fr_fr2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} sur 1 série`);
	return /** @type {LocalizedString} */ (`${i?.done} sur ${i?.total} séries`)
	
};

const de_de2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Satz`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.total} Sätzen`)
	
};

const it_it2_shell_live_sets = /** @type {(inputs: Shell_Live_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 serie`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.total} serie`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "{done} of 1 set" |
* | * | "{done} of {total} sets" |
*
* @param {Shell_Live_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_live_sets = /** @type {((inputs: Shell_Live_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Live_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_live_sets(inputs)
	if (locale === "es-419") return es_419_shell_live_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_live_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_live_sets(inputs)
	if (locale === "de-DE") return de_de2_shell_live_sets(inputs)
	if (locale === "it-IT") return it_it2_shell_live_sets(inputs)
	return en_us2_shell_live_sets(inputs)
});
export { shell_live_sets as "shell.live_sets" }